import { z } from "zod";

export const AiNoticeSchema = z.object({
  enabled: z.boolean(),
  text: z.string().trim().min(1),
  version: z.string().trim().min(1),
  reprompt_days: z.number().int().positive().optional(),
});

export type AiNotice = z.infer<typeof AiNoticeSchema>;

export const AiNoticeAcknowledgementSchema = z.object({
  version: z.string().trim().min(1),
  acknowledgedAt: z.iso.datetime(),
});

export type AiNoticeAcknowledgement = z.infer<typeof AiNoticeAcknowledgementSchema>;
